import { render, staticRenderFns } from "./roomFeeImportList.vue?vue&type=template&id=60f1178c&scoped=true"
import script from "./roomFeeImportList.vue?vue&type=script&lang=js"
export * from "./roomFeeImportList.vue?vue&type=script&lang=js"
import style0 from "./roomFeeImportList.vue?vue&type=style&index=0&id=60f1178c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f1178c",
  null
  
)

export default component.exports